import { render, staticRenderFns } from "./TreeDataBase.vue?vue&type=template&id=32d6ff70&"
import script from "./TreeDataBase.vue?vue&type=script&lang=js&"
export * from "./TreeDataBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports